import {Component, OnInit} from "@angular/core";
import {ApiService} from "../../shared/services/api.service";
import {ActivatedRoute, Router} from "@angular/router";

declare interface RouteInfo {
  path: string;
  title: string;
  rtlTitle: string;
  icon: string;
  class: string;
  children: any;
  id: string
}

export const ROUTES: RouteInfo[] = [
  {
    id:'service-map',
    path: "/manager/service-map",
    title: "ServiceMap",
    rtlTitle: "لوحة القيادة",
    icon: "icon-square-pin",
    class: "",
    children: [{title:'Locations', path:"/manager/service-map", style: 'block'},{title: 'Setting', path:'service-map/setting', style: 'block'}]
  },
  {
    id: 'training',
    path: "/manager/training",
    title: "Training",
    rtlTitle: "لوحة القيادة",
    icon: "icon-paper",
    class: "",
    children: [{title: 'Categories', path: '/manager/training'},
      // {title: 'AddCategory', path: '/manager/edit-category/0'},
      // {title: 'AddPost', path: '/manager/post/0'},
      {title: 'Posts', path: 'posts'},{title:'', path: 'manager/edit-category', style: 'none'},{title:'', path:'manager/post', style: 'none'}]
  },
  {
    id: 'nature',
    path: "/manager/nature",
    title: "Temperamentology",
    rtlTitle: "لوحة القيادة",
    icon: "icon-heart-2",
    class: "",
    children: [{title: 'Natures', path: '/manager/nature'}, {title: 'Questions', path: '/manager/questions'}]
  },
  // {
  //   path: "/manager/Jobino",
  //   title: "Jobino",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //   children: []
  // },
  // {
  //   path: "/manager/MyPatient",
  //   title: "MyPatient",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //   children: []
  // },
  // {
  //   path: "/manager/Pharmacy",
  //   title: "Pharmacy",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //   children: []
  // },
  {
    id:'diets',
    path: "/manager/diets",
    title: "Diet",
    rtlTitle: "لوحة القيادة",
    icon: "icon-user-run",
    class: "",
    children: [{title: 'Diets', path: '/manager/diets/'}, 
      {title: 'Questions', path: '/manager/diet/questions'},
      {title: 'Units', path:'/manager/diet/units'},
      {title: 'calories-category', path:'/manager/diet/calories-category'},
      {title: 'calories-unit', path: '/manager/diet/calories-unit'},
      {title: 'calories-amount', path: '/manager/diet/calories-amount'},
      {title: 'user-calories', path: '/manager/diet/user-calories'}]
  },
  // {
  //   path: "/manager/OnlineAttari",
  //   title: "OnlineAttari",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //   children: []
  // },
  // {
  //   path: "/manager/HealthFolder",
  //   title: "HealthFolder",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //   children: []
  // },
  // {
  //   path: "/manager/HealthStore",
  //   title: "HealthStore",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //   children: []
  // },
  // {
  //   path: "/manager/MedicalFormulary",
  //   title: "MedicalFormulary",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //   children: []
  // },
  // {
  //   path: "/manager/Reservation",
  //   title: "Reservation",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //   children: []
  // },
  // {
  //   path: "/manager/HabitTracker",
  //   title: "HabitTracker",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //   children: []
  // },
  {
    id:'pharmacology',
    path: "/manager/pharmacology/drugs",
    title: "pharmacology",
    rtlTitle: "لوحة القيادة",
    icon: "icon-atom",
    class: "",
    children:  [{title: 'Drugs', path: '/manager/pharmacology/drugs'},{title: 'DrugsTranslate', path: '/manager/pharmacology/translate-drugs'}]
  },
  {
    id:'medical-diagnosis',
    path: "/manager/medical-diagnosis/categories",
    title: "MedicalDiagnosis",
    rtlTitle: "لوحة القيادة",
    icon: "icon-sound-wave",
    class: "",
    children: [{title: 'Categories', path: '/manager/medical-diagnosis/categories'}, {
      title: 'Results',
      path: '/manager/medical-diagnosis/results'
    }, {title: 'Questions', path: '/manager/medical-diagnosis/questions-category'}]
  },
  // {
  //   path: "/manager/MobileMedicalServices",
  //   title: "MobileMedicalServices",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //     children: []
  // },
  {
    id:'hobbies',
    path: "/manager/hobbies",
    title: "Entertainment",
    rtlTitle: "لوحة القيادة",
    icon: "icon-controller",
    class: "",
    children: []
  },
  // {
  //   path: "/manager/SocialMedia",
  //   title: "SocialMedia",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //     children: []
  // },
  // {
  //   path: "/manager/FinancialHealth",
  //   title: "FinancialHealth",
  //   rtlTitle: "لوحة القيادة",
  //   icon: "icon-chart-pie-36",
  //   class: "",
  //   children: []
  // },
  // {
  //   path: "/manager/dasboard",
  //   title: "dasboard",
  //   rtlTitle: "الرموز",
  //   icon: "icon-atom",
  //   class: ""
  // },
  // {
  //   path: "/manager/icons",
  //   title: "Icons",
  //   rtlTitle: "الرموز",
  //   icon: "icon-atom",
  //   class: ""
  // },
  // {
  //   path: "/maps",
  //   title: "Maps",
  //   rtlTitle: "خرائط",
  //   icon: "icon-pin",
  //   class: "" },
  // {
  //   path: "/notifications",
  //   title: "Notifications",
  //   rtlTitle: "إخطارات",
  //   icon: "icon-bell-55",
  //   class: ""
  // },
  //
  // {
  //   path: "/user",
  //   title: "User Profile",
  //   rtlTitle: "ملف تعريفي للمستخدم",
  //   icon: "icon-single-02",
  //   class: ""
  // },
  // {
  //   path: "/tables",
  //   title: "Table List",
  //   rtlTitle: "قائمة الجدول",
  //   icon: "icon-puzzle-10",
  //   class: ""
  // },
  // {
  //   path: "/typography",
  //   title: "Typography",
  //   rtlTitle: "طباعة",
  //   icon: "icon-align-center",
  //   class: ""
  // },
  // {
  //   path: "/rtl",
  //   title: "RTL Support",
  //   rtlTitle: "ار تي ال",
  //   icon: "icon-world",
  //   class: ""
  // }
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
  styles: [`.router-link-active { background-color: red; }`]
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  test: Date = new Date();

  constructor(public apiService: ApiService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);


  }

  isMobileMenu() {
    if (window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  openSbmenu(id,i) {
    for(let i=0; i<ROUTES.length; i++){
      document.getElementById(ROUTES[i].id).classList.remove('activeMenu')
    }
    var x = document.querySelectorAll(".show");
    for (let i = 0; i < x.length; i++) {
      x[i].classList.remove('show')
    }
    document.getElementById(i).classList.add('show');
    document.getElementById(id).classList.add('activeMenu')

  }

  reload() {
    window.location.reload();
  }

  // $sideHeaderNav.on('click', 'li a, li .menu-expand', function (e) {
  //   var $this = $(this);
  //   if ($this.parent('li').hasClass('has-sub-menu') || ($this.attr('href') === '#' || $this.hasClass('menu-expand'))) {
  //     e.preventDefault();
  //     if ($this.siblings('ul:visible').length) {
  //       $this.parent('li').removeClass('active').children('ul').slideUp().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-up').addClass('zmdi-chevron-down');
  //       $this.parent('li').siblings('li').removeClass('active').find('ul:visible').slideUp().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-up').addClass('zmdi-chevron-down');
  //     } else {
  //       $this.parent('li').addClass('active').children('ul').slideDown().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-down').addClass('zmdi-chevron-up');
  //       $this.parent('li').siblings('li').removeClass('active').find('ul:visible').slideUp().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-up').addClass('zmdi-chevron-down');
  //     }
  //   }
  // });

  setActiveSubmenu(id,event) {
     console.log(event);
     console.log(location.pathname)
//    for(let i=0; i<ROUTES.length; i++){
// document.getElementById(ROUTES[i].id).style.backgroundColor='transparent'
//     }
//
//     document.getElementById(id).style.backgroundColor='#484a61'

    // const url = window.location.hash
    // console.log(url.split('/')[1])
    // for(let i=0; i<ROUTES.length; i++){
    //   for(let j=0; j<ROUTES[i].children; j++){
    //     if(ROUTES[i].children[j].path == url){
    //       ROUTES[i].children[j].title = 'test';
    //     }
    //   }
    // }
  }


}
